import { ArrowUpRight12 } from '@mgonetwork/icons';
import { type MgoValidatorSummary } from '@mgonetwork/mango.js/client';
import { Heading, Text } from '@mgonetwork/ui';

import { StakeButton } from './StakeButton';
import { CopyToClipboard } from '~/ui/CopyToClipboard';
import { DescriptionList, DescriptionItem } from '~/ui/DescriptionList';
import { ImageIcon } from '~/ui/ImageIcon';
import { AddressLink } from '~/ui/InternalLink';
import Search from '~/components/search/Search';

type ValidatorMetaProps = {
	validatorData: MgoValidatorSummary;
};

export function ValidatorMeta({ validatorData }: ValidatorMetaProps) {
	const validatorPublicKey = validatorData.protocolPubkeyBytes;
	const validatorName = validatorData.name;
	const logo = validatorData.imageUrl;
	const description = validatorData.description;
	const projectUrl = validatorData.projectUrl;
	return (
		<>
			<div
				className="flex basis-full justify-between border-transparent border-r-gray-45 pt-5 md:basis-1/3"
				// style={{ alignItems: 'center' }}
			>
				<div className="mt-1.5 flex flex-col">
					<Heading as="h1" variant="heading2/bold" color="defined-node-title">
						<div className="flex">
							<span className="mr-2.5">{validatorName}</span>
							<ImageIcon
								src={logo}
								label={validatorName}
								fallback={validatorName}
								circle
								size="sm"
							/>
						</div>
					</Heading>
					{projectUrl && (
						<a
							href={projectUrl}
							target="_blank"
							rel="noreferrer noopener"
							className="mt-2.5 inline-flex items-center gap-1.5 text-body font-medium text-mgo-dark no-underline "
						>
							{projectUrl.replace(/\/$/, '')}
							<ArrowUpRight12 className="text-steel" />
						</a>
					)}
					<div className="defined-stake-btn-container mt-3.5">
						<StakeButton />
					</div>
				</div>
				<div className="w-[600px]">
					<Search />
				</div>
			</div>
			<div className="border-bc-1 mt-7.5 min-w-0 basis-full break-words rounded-[8px] p-5 md:basis-2/3">
				<DescriptionList bg>
					<DescriptionItem
						title={
							<Text variant="pBody/normal" color="defined-node-label">
								Description
							</Text>
						}
						align="start"
					>
						<Text variant="pBody/normal" color="defined-node-text">
							{description || '--'}
						</Text>
					</DescriptionItem>
					<DescriptionItem
						title={
							<Text variant="pBody/normal" color="defined-node-label">
								Location
							</Text>
						}
						align="start"
					>
						<Text variant="pBody/normal" color="defined-node-text">
							--
						</Text>
					</DescriptionItem>
					<DescriptionItem
						title={
							<Text variant="pBody/normal" color="defined-node-label">
								Pool ID
							</Text>
						}
						align="start"
					>
						<div className="flex items-start gap-1 break-all">
							<Text variant="pBody/normal" color="defined-node-text">
								{validatorData.stakingPoolId}
							</Text>
							<CopyToClipboard size="sm" color="defined" copyText={validatorData.stakingPoolId} />
						</div>
					</DescriptionItem>
					<DescriptionItem
						title={
							<Text variant="pBody/normal" color="defined-node-label">
								Address
							</Text>
						}
						align="start"
					>
						<div className="flex items-start gap-1">
							<AddressLink variant="text2" address={validatorData.mgoAddress} noTruncate />
							<CopyToClipboard size="sm" color="defined" copyText={validatorData.mgoAddress} />
						</div>
					</DescriptionItem>
					<DescriptionItem
						title={
							<Text variant="pBody/normal" color="defined-node-label">
								Public Key
							</Text>
						}
						align="start"
					>
						<Text variant="pBody/normal" color="defined-node-text">
							{validatorPublicKey}
						</Text>
					</DescriptionItem>
				</DescriptionList>
			</div>
		</>
	);
}
